module.exports = __webpack_public_path__ + "wxMicroService/img/autumn.7541448a.png";